import type { RateRepository } from '@/core/rate'
import type { UseCase } from '@/core/shared'

export const editRate: UseCase<RateRepository, 'editRate'> = repository => {
  return async (payload) => {
    await repository.editRate(payload)
  }
}
